import { createSlice } from "@reduxjs/toolkit";
export const modalState = {
  open: false,
  message: "",
  type: "",
  image:"",
  title:"",
  routeHome: true,
  error: "",
};
export const modalSlice = createSlice({
  name: "modal",
  initialState: modalState,
  reducers: {
    setModalAttributes(state, action) {
      state.open = action?.payload?.open;
      state.message = action?.payload?.message;
      state.type = action?.payload?.type;
     if (action?.payload?.title) state.title = action?.payload?.title;
     if (action?.payload?.image) state.image = action?.payload?.image;
     if (action?.payload?.routeHome !== undefined) state.routeHome = action?.payload?.routeHome;
     if (action?.payload?.error) state.error = action?.payload?.error;
     if (action?.payload?.buttonLabel) state.buttonLabel = action?.payload?.buttonLabel;
     if (Object.hasOwn(action?.payload, "isRouting")) state.isRouting = action?.payload?.isRouting;
     if (Object.hasOwn(action?.payload, "targetRoute")) state.targetRoute = action?.payload?.targetRoute;
    },
  },
});

export const { setModalAttributes } = modalSlice.actions;
